export default __webpack_public_path__ + "static/media/day2.2262ef94.svg";